import styled from 'styled-components';

import { baseFontFamily, baseFontSize } from 'views/services/font-scheme';
import { baseColor, textColor } from 'views/services/color-scheme';

import { getBackgroundCss } from '../../services/background-css';

export const Root = styled.article`
  background-color: ${baseColor};
  border-radius: 8px;
  padding: 32px;
  width: 560px;
  & > h1 {
    font-family: ${baseFontFamily};
    font-size: calc(${baseFontSize} * 1.5);
    color: ${textColor};
  }
  & > fieldset {
    margin-top: 16px;
    & > div {
      margin-top: 16px;
    }
  }
`;

export const Category = styled.div`
  font-size: calc(${baseFontSize} * 1.25);
`;

export const ValueAndSymbol = styled.div`
  font-size: calc(${baseFontSize} * 1.25);
  display: flex;
  align-items: end;
  gap: 16px;
  & > div {
    flex: 1;
  }
`;

export const NetAndGross = styled.div`
  font-size: calc(${baseFontSize} * 1.25);
  display: flex;
  align-items: end;
  gap: 16px;
  & > div {
    flex: 1;
  }
`;

export const Footer = styled.footer`
  font-size: calc(${baseFontSize} * 1);
  margin-top: 64px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
`;

export const MoreActions = styled.div`
  position: absolute;
  bottom: 24px;
  left: calc(100% + 8px);
  & > div {
    background-color: ${baseColor};
    font-size: calc(${baseFontSize} * 1.25);
    border-radius: 50%;
    ${getBackgroundCss({ zIndex: 4 })}
  }
`;
